import { Children, useEffect, useRef } from 'react';

import useLogger from '@/hooks/useLogger';
import { LoggerParams } from '@/types/log';

interface Props {
  children: React.ReactElement;
  params: LoggerParams;
}
const ClickLogger = (props: Props) => {
  const {
    children,
    params: { eventName, payload },
  } = props;

  const { log } = useLogger();
  const child = Children.only(children);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleLog = (_e: Event) => {
      const evaluatedPayload = typeof payload === 'function' ? payload() : payload;
      log({ eventName, payload: evaluatedPayload });
    };

    const wrapper = wrapperRef.current;

    if (wrapper) {
      wrapper.addEventListener('click', handleLog, { capture: true });

      return () => {
        wrapper.removeEventListener('click', handleLog, { capture: true });
      };
    }
  }, [eventName, payload, log]);

  return (
    <div ref={wrapperRef} className='contents'>
      {child}
    </div>
  );
};

export default ClickLogger;
